import { Component, Input } from '@angular/core';
import { takeUntil } from 'rxjs/operators';

import { BaseComponent, ModalService } from '../../../../tms-shared';
import { AddressDetails, CustomerAddressEdit } from '../../../models';
import { AddressService, CustomerAddressService } from '../../../services';

@Component({
  selector: 'app-customer-address-create-modal',
  templateUrl: './customer-address-create-modal.component.html',
  styleUrl: './customer-address-create-modal.component.scss',
})
export class CustomerAddressCreateModalComponent extends BaseComponent {
  @Input() id: string; // customerId

  constructor(
    public addressService: AddressService,
    private customerAddressService: CustomerAddressService,
    private modalService: ModalService,
  ) {
    super();
  }

  saved(model: AddressDetails) {
    const customerAddress = { addressId: model.id, customerId: this.id } as CustomerAddressEdit;
    this.customerAddressService
      .save(customerAddress)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.modalService.close(customerAddress));
  }
}
